import React, { useEffect, useState, useMemo }  from 'react'
import {Flex,Space,Descriptions,Spin} from 'antd'
import LedgerIncomeList from './LedgerIncomeList';
import { useBusinessNumUpdateQuery } from '../../store/ReactWebSiteApi';
import LedgerIncomeAdd from './LedgerIncomeAdd';
import LedgerEdit from './LedgerEdit';
import LedgerDel from './LedgerDel';
import LedgerAudit from './LedgerAudit';
import LedgerCostList from './LedgerCostList';
import LedgerCostAdd from './LedgerCostAdd';
import LedgerAuditTag from './LedgerAuditTag';

function LedgerDesc(props) {
    const [info,setInfo] = useState({
        profit:'',
        cost:'',
        ebn_update_ctime:"",
        ebn_update_uname:"",
        guigeInfo:'',
        ec_name:'',
        ed_name:'',
        eg_name:'',
        ebn_date:'',
        ebn_uname:'',
        ebn_content:'',
        ebn_ctime:'',
        ebn_audit_uname:'',
        ebn_audit_ctime:'',
        ebn_audit2_ctime:'',
        ebn_audit2_uname:'',                    
        ebn_yw_name:'',
        ebn_team_num:'',
    })
    const {data,isSuccess,isLoading,error} = useBusinessNumUpdateQuery({ebn_id:props.ebn_id},{refetchOnFocus:true,skip:!props.ebn_id})
    
    // 使用 useMemo 优化数据处理，避免每次渲染都重新计算
    const processedData = useMemo(() => {
        if (!isSuccess || !data || data.Status !== 'success') {
            return null;
        }
        
        const result = data.Result;
        const audit = !!result.ebn_audit_ctime;
        
        // 优化 guigeInfo 计算
        const guigeInfo = result.guige ? result.guige.map((item) => (
            <span key={item.egg_id} egg_name={item.egg_name}>
                {item.egg_name + ' × ' + item.guigeNum}
            </span>
        )) : [];
        
        return {
            ebn_audit_ctime: result.ebn_audit_ctime,
            ebn_dept_id: result.ebn_dept_id,
            audit,
            ebn_eg_id: result.ebn_eg_id,
            ebn_team_num: result.ebn_team_num,                        
            eg_name: result.eg_name,                        
            guige: result.guige, 
            ec_name: result.ec_name, 
            ebn_client_id: result.ebn_client_id, 
            ebn_yw_id: result.ebn_yw_id,                                                
            ebn_yw_name: result.ebn_yw_name,  
            ed_name: result.ed_name,
            ebn_date: result.ebn_date,
            ebn_uname: result.ebn_uname,
            ebn_content: result.ebn_content,
            ebn_ctime: result.ebn_ctime,
            ebn_update_ctime: result.ebn_update_ctime,
            ebn_update_uname: result.ebn_update_uname,
            ebn_audit_uname: result.ebn_audit_uname,
            ebn_audit2_ctime: result.ebn_audit2_ctime,
            ebn_audit2_uname: result.ebn_audit2_uname,    
            ebn_audit3_ctime: result.ebn_audit3_ctime,
            ebn_audit3_uname: result.ebn_audit3_uname,    
            ebn_audit4_ctime: result.ebn_audit4_ctime,
            ebn_audit4_uname: result.ebn_audit4_uname,    
            ebn_income_num: result.ebn_income_num,    
            ebn_expenditure_num: result.ebn_expenditure_num,    
            ebn_state: result.ebn_state,    
            guigeInfo,                                                      
        };
    }, [data, isSuccess]);
    
    useEffect(() => {
        if (processedData) {
            setInfo(processedData);
        }
    }, [processedData]);
    // 使用 useMemo 优化 items 数组，避免每次渲染都重新创建
    const items = useMemo(() => [
        {
            key: '1',
            label: '团号',
            children: info.ebn_team_num,            
        },
        {
            key: '2',
            label: '客户',
            children: info.ec_name,
        },
        {
            key: '8',
            label: '操作员',
            children: info.ebn_ctime + info.ebn_uname,
        },
        {
            key: '3',
            label: '出发日期',
            children: info.ebn_date,
        },
        {
            key: '4',
            label: '产品',
            children: info.eg_name,
        },    
        {
            key: '10',
            label: '审核',
            children: <LedgerAuditTag 
                ebn_audit_uname={info.ebn_audit_uname} 
                ebn_audit2_uname={info.ebn_audit2_uname} 
                ebn_audit3_uname={info.ebn_audit3_uname} 
                ebn_audit4_uname={info.ebn_audit4_uname} 
                ebn_audit_ctime={info.ebn_audit_ctime} 
                ebn_audit2_ctime={info.ebn_audit2_ctime} 
                ebn_audit3_ctime={info.ebn_audit3_ctime} 
                ebn_audit4_ctime={info.ebn_audit4_ctime} 
                ebn_id={info.key}
                ebn_state={info.ebn_state}
                direction='horizontal'
            />,
        },    
        {
            key: '12',
            label: '部门',
            children: info.ed_name,
        },
        {
            key: '5',
            label: '备注',
            children: info.ebn_content,
        },
        {
            key: '13',
            label: '数量',
            children: <Space direction='vertical'>{info.guigeInfo}</Space>
        },  
        {
            key: '7',
            label: '销售员',
            children: info.ebn_yw_name,
        },
        {
            key: '6',
            label: '利润',
            children: (+info.ebn_income_num + +info.ebn_expenditure_num).toFixed('2'),
        },
        {
            key: '12',
            label: '操作',
            children: <Space>                            
                <LedgerEdit 
                    ebn_id={props.ebn_id}  
                    ebn_dept_id={info.ebn_dept_id}
                    ebn_audit_ctime={info.ebn_audit_ctime} 
                    fromLedger
                    ebn_state={info.ebn_state}
                />
                <LedgerDel  
                    ebn_id={props.ebn_id}
                    ebn_audit_ctime={info.ebn_audit_ctime} 
                    ebn_state={info.ebn_state}
                />
                <LedgerAudit 
                    ebn_audit4_ctime={info.ebn_audit4_ctime}
                    ebn_audit3_ctime={info.ebn_audit3_ctime}
                    ebn_audit2_ctime={info.ebn_audit2_ctime}
                    ebn_audit_ctime={info.ebn_audit_ctime} 
                    ebn_id={props.ebn_id}
                    ebn_state={info.ebn_state}
                />
            </Space>,
        },
    ], [info, props.ebn_id]);
    // 错误处理
    if (error) {
        return (
            <div style={{border:'2px solid #eee',margin:"10px"}}>
                <Flex justify='center'>
                    <h2>团队台账</h2>
                </Flex>
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <h3>数据加载失败</h3>
                    <p>请检查网络连接或联系管理员</p>
                </div>
            </div>
        );
    }
    
    return (
        <div style={{border:'2px solid #eee',margin:"10px"}}>
            <Flex justify='center'>
                <h2>团队台账</h2>
            </Flex>
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Spin size='large' />
                </div>
            ) : info.ec_name ? (
                <Descriptions
                    bordered
                    size='small' 
                    items={items} 
                />
            ) : (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <p>暂无数据</p>
                </div>
            )}
            {info.ec_name && (
                <>
                    <div style={{marginTop:"15px"}}>
                        <LedgerIncomeAdd style={{marginLeft:"15px"}} 
                            ebn_audit_ctime={info.ebn_audit_ctime}
                            eie_type_id='1' 
                            title='团队收入'
                            ebn_dept_id={info.ebn_dept_id}
                            eie_ebn_id={props.ebn_id}
                            eie_eg_id={info.ebn_eg_id}
                            eg_name={info.eg_name}
                            guige={info.guigeInfo}
                            ebn_client_id={info.ebn_client_id}
                            ec_name={info.ec_name}
                            eie_jbr_uid={info.ebn_yw_id}
                            ebn_yw_id={info.ebn_yw_id}
                            ebn_yw_name={info.ebn_yw_name}
                        />            
                    </div>
                    <LedgerIncomeList 
                        eie_type_id='1'//主类型id
                        title='团队收入'
                        action='search'
                        ebn_dept_id={info.ebn_dept_id}
                        eie_ebn_id={props.ebn_id}
                        pagination={{position:['none'],defaultPageSize:100}}
                        audit={info.audit}
                        ebn_eg_id={info.ebn_eg_id}
                        eg_name={info.eg_name}
                        guige={info.guigeInfo}
                        fromLedger
                    />
                    <div style={{marginTop:"15px"}}>
                        <LedgerCostAdd style={{marginLeft:"15px"}} 
                            ebn_audit_ctime={info.ebn_audit_ctime}
                            eie_type_id='2' 
                            title='团队支出'
                            ebn_dept_id={info.ebn_dept_id}
                            eie_ebn_id={props.ebn_id}
                            eie_eg_id={info.ebn_eg_id}
                            eie_jbr_uid={info.ebn_yw_id}
                        />  
                    </div>
                    <LedgerCostList
                        eie_type_id='2'//主类型id
                        title='团队支出'
                        eie_esv_id='14'
                        action='search'
                        ebn_dept_id={info.ebn_dept_id}
                        eie_ebn_id={props.ebn_id}
                        pagination={{position:['none'],defaultPageSize:100}}
                        audit={info.audit}
                        ebn_eg_id={info.ebn_eg_id}
                        ebn_yw_id={info.ebn_yw_id}
                        ebn_yw_name={info.ebn_yw_name}
                    />
                </>
            )}
        </div>
    )
}

export default LedgerDesc